"use client"

import { cn } from "@/lib/utils"
import { useTranslations } from "next-intl"
import type React from "react"

// Extracted from components/booru-detail-modal.tsx (pure move: same JSX, same behaviour).
interface DeviceStatusIndicatorProps {
  activeScriptId: string | null
  activeScriptName: string | null
  connectedDeviceName: string | null
  hideUI: boolean
  isDeviceConnected: boolean
  setShowQuickConnect: React.Dispatch<React.SetStateAction<boolean>>
}

export function DeviceStatusIndicator({
  activeScriptId,
  activeScriptName,
  connectedDeviceName,
  hideUI,
  isDeviceConnected,
  setShowQuickConnect,
}: DeviceStatusIndicatorProps) {
  const tt = useTranslations("booruDetailModal")
  return (
    <>
      {!hideUI && activeScriptId && (
                <div className="absolute bottom-4 right-4 z-30 pointer-events-auto">
                  <button
                    type="button"
                    disabled={isDeviceConnected}
                    onClick={() => setShowQuickConnect(true)}
                    className={cn(
                      "bg-black/80 rounded-lg px-3 py-2 text-xs text-left",
                      !isDeviceConnected && "hover:bg-black/90 cursor-pointer"
                    )}
                  >
                    <div className="flex items-center gap-2 text-white">
                      <div className={cn(
                        "h-2 w-2 rounded-full",
                        isDeviceConnected ? "bg-green-400 animate-pulse" : "bg-red-400"
                      )} />
                      <span>{connectedDeviceName || "No device"}</span>
                    </div>
                    {isDeviceConnected && (
                      <div className="text-white/60 mt-1">
                        {tt("scriptActiveScriptName", { activeScriptName: activeScriptName ?? "" })}
                      </div>
                    )}
                  </button>
                </div>
              )}
    </>
  )
}
